"use strict";

var _slicedToArray = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var cov_1qv4vyquqi = function () {
  var path = "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/application-bar/UserMenu.js";
  var hash = "cae4f4a159ff7783c250a108dd939eeacee00e75";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/application-bar/UserMenu.js",
    statementMap: {
      "0": {
        start: {
          line: 23,
          column: 28
        },
        end: {
          line: 23,
          column: 43
        }
      },
      "1": {
        start: {
          line: 24,
          column: 21
        },
        end: {
          line: 24,
          column: 42
        }
      },
      "2": {
        start: {
          line: 24,
          column: 27
        },
        end: {
          line: 24,
          column: 42
        }
      },
      "3": {
        start: {
          line: 25,
          column: 20
        },
        end: {
          line: 25,
          column: 40
        }
      },
      "4": {
        start: {
          line: 25,
          column: 26
        },
        end: {
          line: 25,
          column: 40
        }
      },
      "5": {
        start: {
          line: 27,
          column: 31
        },
        end: {
          line: 38,
          column: 24
        }
      },
      "6": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 36,
          column: 5
        }
      },
      "7": {
        start: {
          line: 29,
          column: 6
        },
        end: {
          line: 31,
          column: 7
        }
      },
      "8": {
        start: {
          line: 30,
          column: 8
        },
        end: {
          line: 30,
          column: 24
        }
      },
      "9": {
        start: {
          line: 32,
          column: 6
        },
        end: {
          line: 35,
          column: 8
        }
      },
      "10": {
        start: {
          line: 33,
          column: 8
        },
        end: {
          line: 33,
          column: 19
        }
      },
      "11": {
        start: {
          line: 34,
          column: 8
        },
        end: {
          line: 34,
          column: 31
        }
      },
      "12": {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 37,
          column: 28
        }
      },
      "13": {
        start: {
          line: 40,
          column: 2
        },
        end: {
          line: 44,
          column: 45
        }
      },
      "14": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 43,
          column: 5
        }
      },
      "15": {
        start: {
          line: 42,
          column: 6
        },
        end: {
          line: 42,
          column: 59
        }
      },
      "16": {
        start: {
          line: 42,
          column: 30
        },
        end: {
          line: 42,
          column: 57
        }
      },
      "17": {
        start: {
          line: 48,
          column: 2
        },
        end: {
          line: 52,
          column: 3
        }
      },
      "18": {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 49,
          column: 88
        }
      },
      "19": {
        start: {
          line: 51,
          column: 4
        },
        end: {
          line: 51,
          column: 48
        }
      },
      "20": {
        start: {
          line: 54,
          column: 28
        },
        end: {
          line: 54,
          column: 35
        }
      },
      "21": {
        start: {
          line: 56,
          column: 2
        },
        end: {
          line: 68,
          column: 3
        }
      },
      "22": {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 67,
          column: 6
        }
      },
      "23": {
        start: {
          line: 70,
          column: 2
        },
        end: {
          line: 81,
          column: 4
        }
      },
      "24": {
        start: {
          line: 84,
          column: 0
        },
        end: {
          line: 108,
          column: 2
        }
      },
      "25": {
        start: {
          line: 110,
          column: 15
        },
        end: {
          line: 121,
          column: 2
        }
      },
      "26": {
        start: {
          line: 110,
          column: 27
        },
        end: {
          line: 121,
          column: 1
        }
      },
      "27": {
        start: {
          line: 123,
          column: 24
        },
        end: {
          line: 123,
          column: 82
        }
      }
    },
    fnMap: {
      "0": {
        name: "UserMenuComponent",
        decl: {
          start: {
            line: 17,
            column: 9
          },
          end: {
            line: 17,
            column: 26
          }
        },
        loc: {
          start: {
            line: 22,
            column: 3
          },
          end: {
            line: 82,
            column: 1
          }
        },
        line: 22
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 24,
            column: 21
          },
          end: {
            line: 24,
            column: 22
          }
        },
        loc: {
          start: {
            line: 24,
            column: 27
          },
          end: {
            line: 24,
            column: 42
          }
        },
        line: 24
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 25,
            column: 20
          },
          end: {
            line: 25,
            column: 21
          }
        },
        loc: {
          start: {
            line: 25,
            column: 26
          },
          end: {
            line: 25,
            column: 40
          }
        },
        line: 25
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 27,
            column: 43
          },
          end: {
            line: 27,
            column: 44
          }
        },
        loc: {
          start: {
            line: 27,
            column: 54
          },
          end: {
            line: 38,
            column: 3
          }
        },
        line: 27
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 32,
            column: 21
          },
          end: {
            line: 32,
            column: 22
          }
        },
        loc: {
          start: {
            line: 32,
            column: 27
          },
          end: {
            line: 35,
            column: 7
          }
        },
        line: 32
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 40,
            column: 12
          },
          end: {
            line: 40,
            column: 13
          }
        },
        loc: {
          start: {
            line: 40,
            column: 18
          },
          end: {
            line: 44,
            column: 3
          }
        },
        line: 40
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 42,
            column: 21
          },
          end: {
            line: 42,
            column: 22
          }
        },
        loc: {
          start: {
            line: 42,
            column: 30
          },
          end: {
            line: 42,
            column: 57
          }
        },
        line: 42
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 110,
            column: 15
          },
          end: {
            line: 110,
            column: 16
          }
        },
        loc: {
          start: {
            line: 110,
            column: 27
          },
          end: {
            line: 121,
            column: 1
          }
        },
        line: 110
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 28,
            column: 4
          },
          end: {
            line: 36,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 28,
            column: 4
          },
          end: {
            line: 36,
            column: 5
          }
        }, {
          start: {
            line: 28,
            column: 4
          },
          end: {
            line: 36,
            column: 5
          }
        }],
        line: 28
      },
      "1": {
        loc: {
          start: {
            line: 29,
            column: 6
          },
          end: {
            line: 31,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 29,
            column: 6
          },
          end: {
            line: 31,
            column: 7
          }
        }, {
          start: {
            line: 29,
            column: 6
          },
          end: {
            line: 31,
            column: 7
          }
        }],
        line: 29
      },
      "2": {
        loc: {
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 43,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 43,
            column: 5
          }
        }, {
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 43,
            column: 5
          }
        }],
        line: 41
      },
      "3": {
        loc: {
          start: {
            line: 48,
            column: 2
          },
          end: {
            line: 52,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 48,
            column: 2
          },
          end: {
            line: 52,
            column: 3
          }
        }, {
          start: {
            line: 48,
            column: 2
          },
          end: {
            line: 52,
            column: 3
          }
        }],
        line: 48
      },
      "4": {
        loc: {
          start: {
            line: 48,
            column: 6
          },
          end: {
            line: 48,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 48,
            column: 6
          },
          end: {
            line: 48,
            column: 20
          }
        }, {
          start: {
            line: 48,
            column: 24
          },
          end: {
            line: 48,
            column: 43
          }
        }],
        line: 48
      },
      "5": {
        loc: {
          start: {
            line: 56,
            column: 2
          },
          end: {
            line: 68,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 56,
            column: 2
          },
          end: {
            line: 68,
            column: 3
          }
        }, {
          start: {
            line: 56,
            column: 2
          },
          end: {
            line: 68,
            column: 3
          }
        }],
        line: 56
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "cae4f4a159ff7783c250a108dd939eeacee00e75"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserMenu = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _icons = require("@material-ui/icons");

var _authentication = require("../authentication");

var _helpers = require("../authentication/helpers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function UserMenuComponent(_ref) {
  var classes = _ref.classes,
      authentication = _ref.authentication,
      onAuthentication = _ref.onAuthentication,
      authenticationConfig = _ref.authenticationConfig;
  cov_1qv4vyquqi.f[0]++;

  var _ref2 = (cov_1qv4vyquqi.s[0]++, (0, _react.useState)(false)),
      _ref3 = _slicedToArray(_ref2, 2),
      modal = _ref3[0],
      setModal = _ref3[1];

  cov_1qv4vyquqi.s[1]++;

  var closeModal = function closeModal() {
    cov_1qv4vyquqi.f[1]++;
    cov_1qv4vyquqi.s[2]++;
    return setModal(false);
  };

  cov_1qv4vyquqi.s[3]++;

  var openModal = function openModal() {
    cov_1qv4vyquqi.f[2]++;
    cov_1qv4vyquqi.s[4]++;
    return setModal(true);
  };

  var updateAuthentication = (cov_1qv4vyquqi.s[5]++, (0, _react.useCallback)(function (_auth) {
    cov_1qv4vyquqi.f[3]++;
    cov_1qv4vyquqi.s[6]++;

    if (_auth) {
      cov_1qv4vyquqi.b[0][0]++;
      cov_1qv4vyquqi.s[7]++;

      if (_auth.remember) {
        cov_1qv4vyquqi.b[1][0]++;
        cov_1qv4vyquqi.s[8]++;
        (0, _helpers.saveAuth)(_auth);
      } else {
        cov_1qv4vyquqi.b[1][1]++;
      }

      cov_1qv4vyquqi.s[9]++;

      _auth.logout = function () {
        cov_1qv4vyquqi.f[4]++;
        cov_1qv4vyquqi.s[10]++;
        (0, _helpers.saveAuth)();
        cov_1qv4vyquqi.s[11]++;
        updateAuthentication();
      };
    } else {
      cov_1qv4vyquqi.b[0][1]++;
    }

    cov_1qv4vyquqi.s[12]++;
    onAuthentication(_auth);
  }, [onAuthentication]));
  cov_1qv4vyquqi.s[13]++;
  (0, _react.useEffect)(function () {
    cov_1qv4vyquqi.f[5]++;
    cov_1qv4vyquqi.s[14]++;

    if (!authentication) {
      cov_1qv4vyquqi.b[2][0]++;
      cov_1qv4vyquqi.s[15]++;
      (0, _helpers.getAuth)().then(function (_auth) {
        cov_1qv4vyquqi.f[6]++;
        cov_1qv4vyquqi.s[16]++;
        return updateAuthentication(_auth);
      });
    } else {
      cov_1qv4vyquqi.b[2][1]++;
    }
  }, [authentication, updateAuthentication]);
  var avatar;
  cov_1qv4vyquqi.s[17]++;

  if ((cov_1qv4vyquqi.b[4][0]++, authentication) && (cov_1qv4vyquqi.b[4][1]++, authentication.user)) {
    cov_1qv4vyquqi.b[3][0]++;
    cov_1qv4vyquqi.s[18]++;
    avatar = _react.default.createElement(_core.Avatar, {
      className: classes.avatar,
      src: authentication.user.avatar_url
    });
  } else {
    cov_1qv4vyquqi.b[3][1]++;
    cov_1qv4vyquqi.s[19]++;
    avatar = _react.default.createElement(_icons.AccountCircle, {
      fontSize: "large"
    });
  }

  var authenticationModal = (cov_1qv4vyquqi.s[20]++, _react.default.createElement("div", null));
  cov_1qv4vyquqi.s[21]++;

  if (modal) {
    cov_1qv4vyquqi.b[5][0]++;
    cov_1qv4vyquqi.s[22]++;
    authenticationModal = _react.default.createElement(_core.Modal, {
      open: true,
      onClose: closeModal
    }, _react.default.createElement(_core.Paper, {
      className: classes.modal
    }, _react.default.createElement(_authentication.Authentication, {
      authentication: authentication,
      onAuthentication: onAuthentication,
      config: authenticationConfig
    })));
  } else {
    cov_1qv4vyquqi.b[5][1]++;
  }

  cov_1qv4vyquqi.s[23]++;
  return _react.default.createElement("div", null, _react.default.createElement(_core.IconButton, {
    "data-test": "user-menu-icon",
    onClick: openModal,
    color: "inherit"
  }, avatar), authenticationModal);
}

cov_1qv4vyquqi.s[24]++;
UserMenuComponent.propTypes = {
  /** Pass a previously returned authentication object to bypass login. */
  authentication: _propTypes.default.shape({
    user: _propTypes.default.object.isRequired,
    token: _propTypes.default.object.isRequired,
    config: _propTypes.default.object.isRequired,
    remember: _propTypes.default.bool
  }),

  /** Callback function to propogate the user/token used for API Authentication. */
  onAuthentication: _propTypes.default.func.isRequired,

  /** Override the default text and errors. Must override all or none. */
  messages: _propTypes.default.shape({
    actionText: _propTypes.default.string.isRequired,
    genericError: _propTypes.default.string.isRequired,
    usernameError: _propTypes.default.string.isRequired,
    passwordError: _propTypes.default.string.isRequired
  }),

  /** Configuration for authentication to work, server and tokenid are required. */
  authenticationConfig: _propTypes.default.shape({
    /** The Gitea server to use when authenticating. */
    server: _propTypes.default.string.isRequired,

    /** The id of the token to create/retrieve that is used for the app. */
    tokenid: _propTypes.default.string.isRequired
  }).isRequired
};
cov_1qv4vyquqi.s[25]++;

var styles = function styles(theme) {
  cov_1qv4vyquqi.f[7]++;
  cov_1qv4vyquqi.s[26]++;
  return {
    avatar: {
      width: '35px',
      height: '35px'
    },
    modal: {
      position: 'absolute',
      top: '10%',
      left: '10%',
      right: '10%'
    }
  };
};

var UserMenu = (cov_1qv4vyquqi.s[27]++, (0, _styles.withStyles)(styles, {
  withTheme: true
})(UserMenuComponent));
exports.UserMenu = UserMenu;